import { useState, useMemo } from "react";

// Helper function to get nested object values
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => current?.[key], obj);
};

export function useSearchFilter(data, searchFields = [], filterField = null) {
  const [searchQuery, setSearchQuery] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const filteredData = useMemo(() => {
    let result = data;

    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      result = result.filter((item) =>
        searchFields.some((field) => {
          const value = getNestedValue(item, field);
          return value && value.toString().toLowerCase().includes(query);
        })
      );
    }

    // Apply category/type filter
    if (filterValue) {
      result = result.filter((item) => {
        const res = getNestedValue(item, filterField);
        return res.value === filterValue;
      });
    }

    return result;
  }, [data, searchQuery, filterValue, searchFields, filterField]);

  const getUniqueFilterOptions = useMemo(() => {
    if (!filterField) return [];
    
    const uniqueValues = [...new Set(
      data.map((item) => getNestedValue(item, filterField)).filter(Boolean)
    )];
    
    return uniqueValues.map((item) => ({
      item,
      /* value: item.value,
      label: item.label, */
    }));
  }, [data, filterField]);

  return {
    searchQuery,
    setSearchQuery,
    filterValue,
    setFilterValue,
    filteredData,
    filterOptions: getUniqueFilterOptions,
  };
}